export default __webpack_public_path__ + "static/media/penguin-1.ff67b4b2.png";